<div *ngIf="!isLoggedIn">
  <app-login></app-login>
</div>
<div *ngIf="isLoggedIn">
  <div *ngIf="isAnonymous">
    <app-login title="Link account"></app-login>
  </div>
  <app-logout></app-logout>
</div>
